// 2. FORMULAIRE DE CONSULTATION
// components/consultation/ConsultationForm.tsx
import React from "react";
import { Calendar, Stethoscope } from "lucide-react";

interface ConsultationFormProps {
  consultationData: {
    date: string;
    observations: string;
    diagnostics: string;
    recommandations: string;
  };
  onUpdate: (field: string, value: string) => void;
}

export const ConsultationForm: React.FC<ConsultationFormProps> = ({
  consultationData,
  onUpdate,
}) => {
  return (
    <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 sm:p-8 rounded-2xl shadow-lg border border-teal-100">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl sm:text-2xl font-bold text-teal-900 flex items-center">
          <div className="bg-teal-100 p-2 rounded-xl mr-3">
            <Stethoscope className="text-teal-600" size={24} />
          </div>
          Fiche de Consultation
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="space-y-2">
          <label className="flex items-center text-sm font-semibold text-gray-700">
            <Calendar className="mr-2 text-teal-600" size={16} />
            Date de consultation
          </label>
          <input
            type="date"
            value={consultationData.date}
            onChange={(e) => onUpdate("date", e.target.value)}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-200 bg-white/80 backdrop-blur-sm"
          />
        </div>
      </div>

      <div className="space-y-6">
        <h4 className="text-xl font-bold text-teal-800 mb-4">Évaluation</h4>
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Observations du Médecin
            </label>
            <textarea
              value={consultationData.observations}
              onChange={(e) => onUpdate("observations", e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-200"
              rows={4}
              placeholder="Observations cliniques et questionnaire..."
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Diagnostic
            </label>
            <textarea
              value={consultationData.diagnostics}
              onChange={(e) => onUpdate("diagnostics", e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-200"
              rows={3}
              placeholder="Diagnostic médical posé..."
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Recommandations
            </label>
            <textarea
              value={consultationData.recommandations}
              onChange={(e) => onUpdate("recommandations", e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-200"
              rows={3}
              placeholder="Conseils, recommandations, hygiène de vie, etc."
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationForm;